import { React, useState, useEffect, useContext } from "react";
import "../../../assets/css/table.css";
import Loading from "react-fullscreen-loading";
import { Link } from "react-router-dom";
import HeaderSection from "../banner/HeaderSection";
import DivLoader from "../../../component/utilities/Spinner";
import DataTable from "react-data-table-component";
import axios from "axios";
import { toast } from "react-toastify";
import * as CONST from "../../../component/config/Constant";
import { Modal, Button } from "react-bootstrap";
import { AuthContext } from "../../../component/context/AuthContext";
import Moment from "moment";
import { differenceInCalendarMonths } from 'date-fns';
import { ViewIcon } from '../../../component/utilities/ActionIcons';
import ExportCsv from "../../../component/export/ExportCsv";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import ShowDetails from '../employee/ShowDetails';

function EmployeeSubscriptionList() {
  const [authUserData, setAuthUserData] = useContext(AuthContext);
  const [fullLoading, setFullLoading] = useState(false);
  const [subscriptionRequests, setSubscriptionRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [show, setShow] = useState(false);

  // Processing fields
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [status, setStatus] = useState("");
  const [remarks, setRemarks] = useState("");
  const [actionError, setActionError] = useState("");
  const [srchEmpStatus, setSrchEmpStatus] = useState("");
  const [srchEmpName, setSrchEmpName] = useState("");
  const [srchEmpEmail, setSrchEmpEmail] = useState("");
  const [srchEmpDepartment, setSrchEmpDepartment] = useState("");
  const [srchdesignation, setsrchDesignation] = useState("");
  const [dptListing, setDptListing] = useState("");
  const [desigListing, setDesigListing] = useState("");
  const [validate, setValidate] = useState({});
  const [filterUsers, setfilterUsers] = useState([]);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [editEmpId, setEditEmpId] = useState("");
  const [isEmpDetailModalShow, setEmpDetailModalShow] = useState(false);
  const [showEmpDetailsModel, setEmpDetailsShowModel] = useState({ show: 'hide' });

  const headerData = [
    { label: "Name", key: "employee_name" },
    { label: "Email", key: "email" },
    { label: "Department", key: "department" },
    { label: "Designation", key: "designation" },
    { label: "Subscription", key: "subscription_name" },
    { label: "Date", key: "date" },
    { label: "Cost", key: "cost" },
    { label: "Duration", key: "duration" },
    { label: "Status", key: "status" },
  ];

  /* DATATABLE state */
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [maxPageLimit, setMaxPageLimit] = useState(10);
  const [minPageLimit, setMinPageLimit] = useState(0);
  const pageNumberLimit = 10;

  let isToken = "";
  let department_id = "";
  let is_admin = 0;
  if (authUserData && authUserData[0]) {
    isToken = authUserData[0].token || "";
    department_id = authUserData[0].department_id || "";
    is_admin = authUserData[0].is_admin || 0;
  }

  useEffect(() => {
    fetchAllSubscriptionRequests(activePage, perPage);
    fetchDeptList();
  }, [activePage]);

  async function fetchDeptList() {
    setLoading(true);
    await axios.get(CONST.GET_DEPARTMENT, {
      headers: { Authorization: `Bearer ${isToken}` }
    })
      .then(res => {
        if (res.data.status === "success") {
          setDptListing(res.data.data);
        }
      })
      .catch(err => toast.error("Error fetching departments"))
      .finally(() => setLoading(false));
  }

  const fetchDesigtList = async (dpt_id) => {
    setSrchEmpDepartment(dpt_id);
    if (!dpt_id) {
      setDesigListing([]);
      setsrchDesignation("");
      return;
    }
    await axios.get(CONST.GET_DESIG_BY_ID + '/' + dpt_id, {
      headers: { Authorization: `Bearer ${isToken}` }
    })
      .then(res => {
        if (res.data.status === "success") {
          setDesigListing(res.data.data);
        }
      })
      .catch(err => toast.error("Error fetching designations"));
  }

  async function fetchAllSubscriptionRequests(page, limit) {
    setLoading(true);
    await axios.get(CONST.GET_ALL_SUBSCRIPTION_REQUESTS, {
      params: {
        page_number: page,
        limit: limit,
        status: srchEmpStatus,
        name: srchEmpName,
        email: srchEmpEmail,
        department_id: srchEmpDepartment,
        designation_id: srchdesignation
      },
      headers: { Authorization: `Bearer ${isToken}` }
    })
      .then(res => {
        if (res.data.status === "success") {
          setSubscriptionRequests(res.data.data);
          setTotalRows(res.data.count || res.data.data.length);
          const transformedData = res.data.data.map(item => {
            const emp = item.employee || item.user || {};
            return {
              employee_name: item.employee_name || (emp.first_name ? `${emp.first_name} ${emp.last_name}` : "N/A"),
              email: emp.email || "N/A",
              department: emp.department?.name || "N/A",
              designation: emp.designation?.name || "N/A",
              subscription_name: item.subscription_name || item.subscriptionType?.name || "N/A",
              date: Moment(item.created_at).format("DD MMM YYYY"),
              cost: `${item.cost} ${item.currency}`,
              duration: `${item.duration} ${item.duration_unit}(s)`,
              status: (item.status || "pending").charAt(0).toUpperCase() + (item.status || "pending").slice(1)
            };
          });
          setfilterUsers(transformedData);
        } else {
          setSubscriptionRequests([]);
          setfilterUsers([]);
        }
      })
      .catch(err => setSubscriptionRequests([]))
      .finally(() => setLoading(false));
  }

  const handleSearch = () => {
    setActivePage(1);
    fetchAllSubscriptionRequests(1, perPage);
  };

  const handleReSetSearch = () => {
    setSrchEmpStatus("");
    setSrchEmpName("");
    setSrchEmpEmail("");
    setSrchEmpDepartment("");
    setsrchDesignation("");
    setActivePage(1);

    setLoading(true);
    axios.get(CONST.GET_ALL_SUBSCRIPTION_REQUESTS, {
      params: {
        page_number: 1,
        limit: perPage,
        status: "",
        name: "",
        email: "",
        department_id: "",
        designation_id: ""
      },
      headers: { Authorization: `Bearer ${isToken}` }
    })
      .then(res => {
        if (res.data.status === "success") {
          setSubscriptionRequests(res.data.data);
          setTotalRows(res.data.count || res.data.data.length);
          const transformedData = res.data.data.map(item => ({
            employee_name: item.employee_name || (item.user ? `${item.user.first_name} ${item.user.last_name}` : "N/A"),
            email: item.user?.email || "N/A",
            department: item.user?.department?.name || "N/A",
            designation: item.user?.designation?.name || "N/A",
            subscription_name: item.subscription_name || item.subscriptionType?.name || "N/A",
            date: Moment(item.created_at).format("DD MMM YYYY"),
            cost: `${item.cost} ${item.currency}`,
            duration: `${item.duration} ${item.duration_unit}(s)`,
            status: (item.status || "pending").charAt(0).toUpperCase() + (item.status || "pending").slice(1)
          }));
          setfilterUsers(transformedData);
        } else {
          setSubscriptionRequests([]);
          setfilterUsers([]);
        }
      })
      .catch(err => setSubscriptionRequests([]))
      .finally(() => setLoading(false));
  };

  const handlePageLimit = (limit) => {
    setPerPage(limit);
    setActivePage(1);
    fetchAllSubscriptionRequests(1, limit);
  };

  const handleShow = (row) => {
    setSelectedRequest(row);
    // Normalize status to match dropdown options
    const lowerStatus = (row.status && row.status.toLowerCase()) || "pending";
    if (lowerStatus === "active" || lowerStatus === "approved") {
      setStatus("active");
    } else if (lowerStatus === "cancelled") {
      setStatus("cancelled");
    } else if (lowerStatus === "rejected") {
      setStatus("rejected");
    } else {
      setStatus(lowerStatus);
    }

    setRemarks(row.admin_remarks || row.rejection_reason || "");
    setActionError("");
    setShow(true);
  };

  const handleClose = () => setShow(false);

  function calculateExperience(startDate, endDate) {
    if (startDate && endDate) {
      const start = new Date(startDate);
      const end = endDate === 'present' ? new Date() : new Date(endDate);

      const totalMonths = differenceInCalendarMonths(end, start);
      const years = Math.floor(totalMonths / 12);
      const months = totalMonths % 12;

      const experience = years + months / 10; // Display one decimal place

      return experience;
    } else {
      return 0;
    }
  }

  const handleEmpDetailsShow = (row) => {
    const employee = row.employee || row.user || {};
    setLoading(true);
    setEmpDetailModalShow(true);
    setEmpDetailsShowModel({ show: 'show' });
    setEditEmpId(employee.id);
    setFirstName(employee.first_name || '');
    setLastName(employee.last_name || '');
    setLoading(false);
  }

  const closeEmpDetails = async (type) => {
    setEmpDetailsShowModel({
      show: 'hide'
    });
  }

  function LinkWithTooltip({ id, children, href, tooltip, css }) {
    return (
      <OverlayTrigger overlay={<Tooltip id={id}>{tooltip}</Tooltip>} placement="top" delayShow={300} delayHide={150}>
        <span className={css}>{children}</span>
      </OverlayTrigger>
    );
  }

  const CustomName = ({ row }) => {
    const employee = row.employee || row.user || {};
    let totalExperience = 0;
    if (employee.euser_has_experiences) {
      employee.euser_has_experiences.map(exe => {
        if (exe.is_current_job == 1) {
          totalExperience = parseFloat(totalExperience) + calculateExperience(exe.start_date, 'present');
        } else {
          if (exe.start_date && exe.end_date) {
            totalExperience = parseFloat(totalExperience) + calculateExperience(exe.start_date, exe.end_date);
          }
        }
      })
    }

    return (
      <div>
        <div className="d-flex py-1 align-items-center">
          {employee.profile_photo_path ? (
            <span className="avatar">
              <img src={CONST.HOST + employee.profile_photo_path} alt='' width={40} className="rounded-circle" />
            </span>
          ) : (
            <span className="avatar rounded-circle">
              <Link to={'#'} data-id={employee.id} onClick={() => handleEmpDetailsShow(row)}>
                {employee.first_name && employee.first_name.substring(0, 1)}
                {employee.last_name && employee.last_name.substring(0, 1)}
              </Link>
            </span>
          )}

          <div className="flex-fill pl-2">
            <div className="font-weight-medium">
              <Link to={'#'} data-id={employee.id} onClick={() => handleEmpDetailsShow(row)}>
                <LinkWithTooltip tooltip="View More Information" id="more-information" css="color_blue">
                  {employee.first_name} {employee.last_name}
                </LinkWithTooltip>
              </Link>
            </div>
            <div className="text-muted">
              <Link target="_blank" to={`mailto:${employee.email}`} className="text-muted small">
                {employee.email && employee.email.toLowerCase()}
              </Link>
            </div>
            <div className="small text-muted">
              <b> Total Exp.:</b> {totalExperience.toFixed(1)} Year(s)
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();

    // Improved robust check for pending status
    if (!status || status.toString().toLowerCase() === "pending") {
      setActionError('"action" must be one of [approved, rejected]');
      return;
    }

    setFullLoading(true);
    const payload = {
      id: selectedRequest.id,
      action: status,
      start_date: Moment().format('YYYY-MM-DD')
    };

    if (status === 'rejected' || status === 'cancelled') {
      payload.rejection_reason = remarks;
      payload.action = status === 'cancelled' ? 'cancelled' : 'rejected';
    } else if (status === 'approved' || status === 'active') {
      payload.action = 'approved';
    }

    await axios.post(CONST.PROCESS_SUBSCRIPTION_REQUEST, payload, {
      headers: { Authorization: `Bearer ${isToken}` }
    })
      .then(res => {
        if (res.data.status === "success") {
          toast.success("Request processed successfully");
          fetchAllSubscriptionRequests(activePage, perPage);
          handleClose();
        } else {
          const msg = res.data.message || "Something went wrong";
          if (msg.includes('"action"')) {
            setActionError(msg);
          } else {
            toast.error(msg);
          }
        }
      })
      .catch(() => toast.error("Something went wrong"))
      .finally(() => setFullLoading(false));
  };

  const capitalizeFirstLetter = (str) => {
    if (!str) return "-";
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const columns = [
    {
      name: "Employee",
      selector: (row) => row.employee_name || "",
      cell: (row) => <CustomName row={row} />,
      width: "28%",
    },
    {
      name: "Subscription",
      selector: (row) => row.subscription_name || row.subscriptionType?.name || "N/A",
      width: "12%",
    },
    {
      name: "Cost",
      selector: (row) => `${row.cost} ${row.currency}`,
      width: "10%",
    },
    {
      name: "Duration",
      selector: (row) => `${row.duration} ${row.duration_unit}(s)`,
      width: "10%",
    },
    {
      name: "Date",
      selector: (row) => Moment(row.created_at).format("DD MMM YYYY"),
      width: "10%",
    },
    {
      name: "Status",
      cell: (row) => (
        <span className={`db-status-badge ${row.status === "approved" || row.status === "active" ? "db-badge-success" :
          row.status === "rejected" || row.status === "cancelled" ? "db-badge-danger" :
            row.status === "expired" ? "bg-secondary" : "db-badge-warning"
          }`}>
          {(row.status || "pending").charAt(0).toUpperCase() + (row.status || "pending").slice(1)}
        </span>
      ),
      width: "10%",
    },
    {
      name: "Remarks",
      selector: (row) => row.rejection_reason || "-",
      width: "10%",
    },
    {
      name: "Action",
      cell: (row) => (
        <button className="btn btn-sm" onClick={() => handleShow(row)}>
          <ViewIcon size={16} className="text-primary" />
        </button>
      ),
      width: "10%",
    }
  ];

  const BootyPagination = ({ rowCount, currentPage, onChangePage }) => {
    const pages = Math.ceil(rowCount / perPage);
    const pageNumbers = [];
    for (let i = 1; i <= pages; i++) {
      if (i <= maxPageLimit && i > minPageLimit) pageNumbers.push(i);
    }

    return (
      <div className="card-footer d-flex align-items-center">
        <p className="m-0 text-muted">Showing {(currentPage - 1) * perPage + 1} to {Math.min(currentPage * perPage, rowCount)} of {rowCount} entries</p>
        <ul className="pagination m-0 ms-auto">
          <li className="page-item"><button className="page-link" disabled={currentPage === 1} onClick={() => onChangePage(currentPage - 1)}>«</button></li>
          {pageNumbers.map(page => (
            <li key={page} className={`page-item ${currentPage === page ? "active" : ""}`}>
              <button className="page-link" onClick={() => onChangePage(page)}>{page}</button>
            </li>
          ))}
          <li className="page-item"><button className="page-link" disabled={currentPage === pages} onClick={() => onChangePage(currentPage + 1)}>»</button></li>
        </ul>
      </div>
    );
  };

  return (
    <>
      <Loading loading={fullLoading} background="rgba(0, 0, 0, 0.5)" loaderColor="#fff" />
      <HeaderSection
        title="Admin"
        heading="Employee Subscription List"
      />
      <div className="page-body">
        <div className="container-xl">
          <div className="card">
            <div className="card-header"><h3 className="card-title">Subscription Requests</h3></div>

            <div className="card-body border-bottom py-3">
              <div className="row">
                <div className="col-md-2">
                  <div className="form-group mb-3 ">
                    <label className="form-label">Name</label>
                    <div>
                      <input
                        type="text"
                        name="srchEmpName"
                        id="srchEmpName"
                        className={`form-control ${validate.validate && validate.validate.srchEmpName ? "is-invalid " : ""}`}
                        placeholder="Enter name"
                        onChange={(e) => setSrchEmpName(e.target.value)}
                        value={srchEmpName}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group mb-3 ">
                    <label className="form-label">Email</label>
                    <div>
                      <input
                        type="text"
                        name="srchEmpEmail"
                        id="srchEmpEmail"
                        className={`form-control ${validate.validate && validate.validate.srchEmpEmail ? "is-invalid " : ""}`}
                        placeholder="Enter email"
                        onChange={(e) => setSrchEmpEmail(e.target.value)}
                        value={srchEmpEmail}
                      />
                    </div>
                  </div>
                </div>

                {(department_id === 5 || department_id === 8 || is_admin == 1) && (
                  <>
                    <div className="col-md-2">
                      <div className="mb-3">
                        <label className="form-label">Department</label>
                        {dptListing ? (
                          <select
                            className="form-select form-control"
                            name="srchEmpDepartment"
                            id="srchEmpDepartment"
                            onChange={(e) => fetchDesigtList(e.target.value)}
                            value={srchEmpDepartment}
                          >
                            <option value="">Select</option>
                            {dptListing.map((element, key) => (
                              <option key={key} value={element.id}>{element.name}</option>
                            ))}
                          </select>
                        ) : (
                          <DivLoader color="primary" />
                        )}
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="mb-3">
                        <label className="form-label">Designation</label>
                        <select
                          className="form-select form-control"
                          name="designation"
                          id="designation"
                          onChange={(e) => setsrchDesignation(e.target.value)}
                          value={srchdesignation}
                        >
                          <option value="">Select</option>
                          {desigListing && desigListing.map((element, key) => (
                            <option key={key} value={element.id}>{element.name}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </>
                )}

                <div className="col-md-2">
                  <div className="mb-3">
                    <label className="form-label">Status</label>
                    <select
                      className="form-select form-control"
                      name="srchEmpStatus"
                      id="srchEmpStatus"
                      onChange={(e) => setSrchEmpStatus(e.target.value)}
                      value={srchEmpStatus}
                    >
                      <option value="">Select</option>
                      <option value="pending">Pending</option>
                      <option value="active">Approved</option>
                      <option value="rejected">Rejected</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group mb-3">
                    <label className="form-label">&nbsp;</label>
                    <div className="d-flex flex-nowrap gap-2">
                      <button
                        type="button"
                        className="btn btn-blue btn-sm px-2 py-1 d-flex align-items-center mr-2"
                        onClick={handleSearch}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="icon icon-tabler icon-tabler-search me-1"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          strokeWidth="2"
                          stroke="currentColor"
                          fill="none"
                        >
                          <circle cx="10" cy="10" r="7"></circle>
                          <line x1="21" y1="21" x2="15" y2="15"></line>
                        </svg>
                        Search
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-primary btn-sm mr-2"
                        onClick={handleReSetSearch}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-x" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                          <line x1="18" y1="6" x2="6" y2="18"></line>
                          <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                        Clear
                      </button>
                      <ExportCsv
                        propsEmpName={filterUsers}
                        propsHeaders={headerData}
                        propsFileName="Employee_Subscriptions.csv"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className="col-md-6">
                  <nav className="limit-pagination pt-3">
                    <span className="">Rows per page:</span>
                    <select
                      aria-label="Rows per page:"
                      className="form-select d-inline-block w-auto ms-2"
                      value={perPage}
                      onChange={(e) => handlePageLimit(e.target.value)}
                    >
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </nav>
                </div>
              </div>
            </div>
            <div className="table-responsive">
              <DataTable
                columns={columns}
                data={subscriptionRequests}
                progressPending={loading}
                progressComponent={<div style={{ padding: '24px' }}><DivLoader color="primary" /></div>}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                onChangePage={setActivePage}
                paginationPerPage={perPage}
                paginationComponent={BootyPagination}
              />
            </div>
          </div>
        </div>
      </div>

      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton><Modal.Title>Process Subscription Request</Modal.Title></Modal.Header>
        <Modal.Body>
          {selectedRequest && (
            <div className="mb-4">
              <div className="row">
                <div className="col-md-12">
                  <CustomName row={selectedRequest} />
                </div>
              </div>
              <hr className="my-3" />

              <div className="row">
                <div className="col-md-6">
                  <p className="mb-1"><strong>Subscription:</strong> <span className="text-muted">{selectedRequest.subscription_name}</span></p>
                  <p className="mb-1"><strong>Cost:</strong> <span className="text-muted">{selectedRequest.cost} {selectedRequest.currency}</span></p>
                </div>
                <div className="col-md-6">
                  <p className="mb-1"><strong>Duration:</strong> <span className="text-muted">{selectedRequest.duration} {selectedRequest.duration_unit}(s)</span></p>
                  <p className="mb-1"><strong>Requested Date:</strong> <span className="text-muted">{Moment(selectedRequest.created_at).format("DD MMM YYYY")}</span></p>
                </div>
              </div>
              <hr className="my-2" />
              <p className="mb-1 font-weight-bold"><strong>Description / Justification:</strong></p>
              <p className="text-muted small">{selectedRequest.description || "N/A"}</p>
            </div>
          )}
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label required">Action</label>
              <select
                className={`form-select ${actionError ? "is-invalid" : ""}`}
                onChange={(e) => {
                  setStatus(e.target.value);
                  if (e.target.value.toLowerCase() !== "pending") {
                    setActionError("");
                  }
                }}
                value={status}
                disabled={selectedRequest && ["expired"].includes(selectedRequest.status.toLowerCase())}
              >
                {selectedRequest && ["active", "approved", "cancelled"].includes(selectedRequest.status.toLowerCase()) ? (
                  <>
                    <option value="active">Active</option>
                    <option value="cancelled">Cancel</option>
                  </>
                ) : (
                  <>
                    <option value="pending">Pending</option>
                    <option value="approved">Approve</option>
                    <option value="rejected">Reject</option>
                  </>
                )}
              </select>
              {actionError && (
                <div className="invalid-feedback">{actionError}</div>
              )}
            </div>
            {(status === "rejected" || status === "cancelled") && (
              <div className="mb-3">
                <label className="form-label required">{status === "cancelled" ? "Cancellation Reason" : "Rejection Reason"}</label>
                <textarea
                  className="form-control"
                  rows="3"
                  placeholder={status === "cancelled" ? "Why is this being cancelled?" : "Why is this being rejected?"}
                  onChange={(e) => setRemarks(e.target.value)}
                  value={remarks}
                  required={status === "rejected" || status === "cancelled"}
                ></textarea>
              </div>
            )}
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Close</Button>
          <Button 
            variant="primary" 
            onClick={handleSubmit} 
            disabled={!selectedRequest || 
                      ["expired"].includes(selectedRequest.status.toLowerCase()) || 
                      (selectedRequest.status.toLowerCase() === status.toLowerCase())
            }
          >
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>

      {showEmpDetailsModel.show === 'show' && (
        <ShowDetails
          closeEmpDetails={closeEmpDetails}
          editEmpId={editEmpId}
          firstName={firstName}
          lastName={lastName}
        />
      )}
    </>
  );
}

export default EmployeeSubscriptionList;
